export const fontSizes = {
    "11xl": { value: "5rem" }, // 80px
    "10xl": { value: "4.5rem" }, // 72px
    "9xl": { value: "4rem" }, // 64px
    "8xl": { value: "3.5rem" }, // 56px
    "7xl": { value: "3rem" }, // 48px
    "6xl": { value: "2.5rem" }, // 40px
    "5xl": { value: "2.25rem" }, // 36px
    "4xl": { value: "1.875rem" }, // 30px
    "3xl": { value: "1.75rem" }, // 28px
    "2xl": { value: "1.5rem" }, // 24px
    "xl": { value: "1.25rem" }, // 20px
    "lg": { value: "1.125rem" }, // 18px
    "md": { value: "1rem" }, // 16px
    "sm": { value: "0.875rem" }, // 14px
    "xs": { value: "0.75rem" }, // 12px
    "2xs": { value: "0.625rem" }, // 10px
    "3xs": { value: "0.563rem" }, // 9px
    "4xs": { value: "0.5rem" }, // 8px
    "5xs": { value: "0.438rem" } // 7px
};
